<template>
    <base-file-input
        v-model="model"
        v-validate="{
            required: false,
        }"
        :required="false"
        :field="field"
        input-id="proofOfEmployment"
        input-label="Proof Of Employment"
        :placeholder="
            originalFileName ||
            'Upload proof of employment document (JPG, PNG or TIFF file)'
        "
        drop-placeholder="Drop file here..."
        file-type="utility"
        accept="image/*"
        data-vv-name="Proof Of Employment"
        :class="{
            'is-invalid': errors.has('Proof Of Employment'),
        }"
        @update:originalFileName="updateOriginalFileName"
    ></base-file-input>
</template>

<script>
import IdentityDocument from './IdentityDocument'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: IdentityDocument, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: false,
                    isLocked: true,
                    key: 'documentInfo.proofOfEmployment.fileName',
                    originalFileNameKey:
                        'documentInfo.proofOfEmployment.originalFileName',
                }
            },
            required: false,
        },
        profileType: {
            type: String,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
